import { useIntl } from 'react-intl';
import { UpdateOptions, toast } from 'react-toastify';

import ExportReportBtn from 'src/feature/bite/component/ExportReportBtn';

import { exportAllCsv } from 'src/feature/bite/helpers/exportCsv';
import { exportAllExcel } from 'src/feature/bite/helpers/exportExcel';

import { useGetAll } from '../../context/useMutation';

function Export({ tableName }: { tableName: string }) {
  const intl = useIntl();
  const { mutateAsync } = useGetAll()

  const toastSuccess: UpdateOptions = {
    render: intl.formatMessage({ id: 'GLOBAL.EXPORT.SUCCESS' }),
    type: 'success',
    isLoading: false,
    autoClose: 5000,
    closeOnClick: true,
  };

  const toastLoading = intl.formatMessage({ id: 'GLOBAL.EXPORT.LOADING' });

  const columns = [
    {
      dataIndex: 'terminalId',
      title: intl.formatMessage({ id: 'TERMINAL.LIST.TERMINAL_ID' }),
    },
    {
      dataIndex: 'typeID',
      title: intl.formatMessage({ id: 'TERMINAL.LIST.TERMINAL_TYPE' }),
      render: (type: any) => {
        switch (type) {
          case 0:
            return "Main";
          default:
            return { type };
        }
      }
    },
    {
      dataIndex: 'statusID',
      title: intl.formatMessage({ id: 'TERMINAL.LIST.STATUS' }),
      status: true
    },
    {
      dataIndex: 'loyaltyStatusID',
      title: intl.formatMessage({ id: 'TERMINAL.LIST.LOYALTY_STATUS' }),
      status: true
    },
    {
      dataIndex: 'lastTrxDate',
      title: intl.formatMessage({ id: 'TERMINAL.LIST.LAST_TRX_DATE' }),
      render: (text: string) => {
        if (!text || text === '0001-01-01T00:00:00Z') return "-";
        return new Date(text).toLocaleDateString('tr-TR') + ' ' + new Date(text).toLocaleTimeString('tr-TR', { hour: 'numeric', minute: 'numeric' })
      }
    },
  ]

  const getAllCsv = async () => {
    const toastId = toast.loading(toastLoading);
    const data = await mutateAsync();

    exportAllCsv(tableName, data, columns);

    toast.update(toastId, toastSuccess);
  };

  const getAllExcel = async () => {
    const toastId = toast.loading(toastLoading);
    const data = await mutateAsync();

    exportAllExcel(tableName, data, columns);

    toast.update(toastId, toastSuccess);
  };

  return (
    <>
      <ExportReportBtn
        exportTable={tableName}
        exportAllCsv={getAllCsv}
        exportAllExcel={getAllExcel}
      />
    </>
  )
}

export default Export
